import axios from "axios";
import {toast} from './Notification'
import store from '@/store'
import {translateBackEndMessages} from "./TranslateBackEndMessages";
import {vueVersion} from "./VueVersion";
import {i18n} from "@/main";

axios.defaults.baseURL = 'https://api.utmtco.com/api/';

function setProjectDomain() {

    window.addEventListener('storageChange', function () {
        // Handle the localStorage change here

        if (require('@/../package.json').name == 'miw-alpha') {
            axios.defaults.baseURL = localStorage.getItem('projectDomain')
        }
    });

}

setProjectDomain()

function checkMessageHaveTranslate(message) {

    const pathSegments = message.split('.');
    let currentObject = translateBackEndMessages;

    for (const segment of pathSegments) {
        if (currentObject.hasOwnProperty(segment)) {
            currentObject = currentObject[segment];
        } else {
            // Path not found, return a default path
            return false;
        }
    }
    return currentObject;
}


function translateBackEndMessagesFunction(message) {

    if (vueVersion() == 2) {
        let checkTranslation = checkMessageHaveTranslate(message)
        if (checkTranslation == false) {
            return message
        }

        return checkTranslation
    } else { // vue3
        return i18n.global.t(message, {})
    }

}

axios.defaults.headers.common['Accept'] = 'application/json'
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem('token')}`

let requestCounter = 0

axios.interceptors.request.use(function (config) {
    store.commit('Loading/setRequestCounter', 1)
    store.commit('Loading/setStatus', true)
    return config
})

axios.interceptors.response.use(
    response => {
        store.commit('Loading/setRequestCounter', -1)
        setTimeout(() => {
            if (store.getters['Loading/requestCounter'] <= 0) {
                store.commit('Loading/setStatus', false)
            }
        }, 0)

        return response
    },
    error => {
        const baseURL = error.config.url;

        if (typeof error.response.data.message == 'string') {
            toast(error.response.data.status, translateBackEndMessagesFunction(error.response.data.message), 'danger')
        } else {
            const errors = error.response.data.message;
            for (const e in errors) {


                if (baseURL.indexOf('https://plus.basalam.com') > -1) {
                    toast(errors[e].message, errors[e].message, 'danger')
                } else {
                    errors[e].forEach(item => {

                        toast(error.response.data.status, translateBackEndMessagesFunction(item), 'danger')

                    })
                }

            }
        }

        store.commit('Loading/setRequestCounter', -1)

        if (store.getters['Loading/requestCounter'] <= 0) {
            store.commit('Loading/setStatus', false)
        }
        return Promise.reject(error)
    },
);